module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6f705ff4dc4bed3d9dd1d96d476c0348.png";